var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"atom-icon",attrs:{"aria-hidden":"true","width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fill},domProps:{"innerHTML":_vm._s(_vm.innerHTML)}})}
var staticRenderFns = []

export { render, staticRenderFns }